import MuiButton from "@mui/material/Button";

const Button = (props: any) => {
  return (
    <MuiButton
      {...props}
      fullWidth={props.fullWidth || true}
      variant={props.variant || "contained"}
      sx={{ color: "white", ...props.sx }}
    />
  );
};

export default Button;
